/** Módulos del portal externo: permisos propios, sin catálogo interno. */
export const PROVIDER_MODULE_DEFS = [
  {
    id: 'bigitem',
    path: '/pedidos',
    icon: 'local_shipping',
    title: 'Pedidos Big Item',
    desc: 'Pedidos asignados a tu empresa, su historial y estadísticas.',
    permiso: 'proveedor.registros.ver',
  },
];

export function visibleProviderModules(permisos) {
  return PROVIDER_MODULE_DEFS.filter((module) => Array.isArray(permisos) && permisos.includes(module.permiso));
}
